<script>
import ProfileCell from '@/components/ProfileCell.vue'
import messages from '../mixins/messages'
import DeveloperProfileResource from '../resources/developerprofile'
import CompanyResource from '../resources/company'
import SalesModal from '@/components/SalesModal.vue'

export default {
    name: 'SalesPageCompany',
    mixins: [messages],
    components: {
        SalesModal,
        ProfileCell
    },
    data() {
        return {
            loading: true,
            demoProfile: null,
            companyResource: null,
        }
    },
    methods: {
        onSuccess() {
            this.$refs.salesModal.close()
            if(this.$route.query.next) {
                this.$router.push(this.$route.query.next)
            } else {
                this.$router.push({ name: 'recruitHome', params: { companyId: this.companyResource.id }})
            }
        }
    },
    async mounted() {
        this.demoProfile = await DeveloperProfileResource.random()
        await this.demoProfile.resolveRelated({ managers: ['image', 'skills'] })
        this.companyResource = await CompanyResource.detail(this.$route.params.companyId)
        this.loading = false
    },
}
</script>

<template>
    <div>
        <section>
            <div class="section-heading text-center mb-0 mt-5">
                <p>Upgrade your Account</p>
                <h2>Select the plan that fits your needs...</h2>
            </div>
        </section>

        <section class="p-md-5 mt-5 gray">
            <b-container>
                <b-card-group class="cost-breakdown" deck>
                    <b-card title="Single Listing">
                        <div class="price">
                            $49
                        </div>
                        <ul>
                            <li>Single Job Listing for 30 days</li>
                            <li>Applications Delivered to your Inbox</li>
                            <li><del class="text-muted">Access to thousands of Engineers</del></li>
                            <li><del class="text-muted">Intelligent Candidate Matching</del></li>
                            <li>
                                <del class="text-muted"> Customize Application Workflow</del>
                            </li>
                        </ul>
                        <template slot="footer">
                            <b-button variant="primary" size="lg" class="col-12" @click="$refs.salesModal.prepay()">
                                <span v-if="companyResource && companyResource.attributes.prepaid_listings > 0">Create More Listings</span>
                                <span v-else>Create a Single Listing</span>
                            </b-button>
                        </template>
                    </b-card>
                    <b-card title="For Teams" class="highlight shadow">
                        <div class="price">
                            $99/mo
                        </div>
                        <ul>
                            <li><strong class="text-magenta">Up to 3</strong> Active Job Listings</li>
                            <li>Applications Delivered to your Inbox</li>
                            <li>
                                <strong><b-icon icon="check" class="text-success" /> Access to thousands of Engineers</strong>
                            </li>
                            <li>
                                <strong><b-icon icon="check" class="text-success" /> Intelligent Candidate Matching</strong>
                            </li>
                            <li>
                                <del class="text-muted"> Customize Application Workflow</del>
                            </li>
                        </ul>
                        <b-badge class="trial-badge" pill>
                            <b-icon icon="patch-check" /> Free 7-Day Trial
                        </b-badge>
                        <template slot="footer">
                            <b-button variant="primary" size="lg" class="col-12" @click="$refs.salesModal.teams()">Choose This Plan</b-button>
                        </template>
                    </b-card>
                    <b-card title="Unlimited">
                        <div class="price">
                            $399/mo
                        </div>
                        <ul>
                            <li><strong class="text-magenta">Unlimited</strong> Active Job Listings</li>
                            <li>Applications Delivered to your Inbox</li>
                            <li>
                                <strong><b-icon icon="check" class="text-success" /> Access to thousands of Engineers</strong>
                            </li>
                            <li>
                                <strong><b-icon icon="check" class="text-success" /> Intelligent Candidate Matching</strong>
                            </li>
                            <li>
                                <strong><b-icon icon="check" class="text-success" /> Customize Application Workflow</strong>
                            </li>
                        </ul>
                        <b-badge class="trial-badge" pill>
                            <b-icon icon="patch-check" /> Free 7-Day Trial
                        </b-badge>
                        <template slot="footer">
                            <b-button variant="primary" size="lg" class="col-12" @click="$refs.salesModal.unlimited()">Choose This Plan</b-button>
                        </template>
                    </b-card>
                </b-card-group>
            </b-container>
        </section>

        <section>
            <b-container>
                <div class="section-heading text-center mb-0 mt-5">
                    <p>Example Profile</p>
                </div>

                <b-row class="mb-5">
                    <b-col md="8" offset-md="2">
                        <b-card class="mb-3">
                            <profile-cell :profile="demoProfile" v-if="demoProfile" />
                            <profile-cell v-else class="mb-3" />
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </section>

        <sales-modal
            :company-resource="companyResource"
            @success="onSuccess"
            ref="salesModal"
            v-if="!loading">
        </sales-modal>

    </div>
</template>

<style lang="scss">
.cost-breakdown {
    .card {
        text-align: center;

        &.highlight {
            border-top-width: 3px;
            border-color: #ce75b4 #faf6fb #fff;
        }

        .card-title {
            font-size: 80%;
            text-transform: uppercase;
            color: #e38cb7;
        }

        .card-footer {
            border: none;
            background: inherit;
        }

        .price {
            font-size: 2.8rem;
            font-weight: 700;
            color: #633991;
        }

        ul {
            list-style: none;
            padding: 0;
            margin-top: 20px;

            li {
                margin-bottom: 15px;
            }
        }
    }

    .trial-badge {
        font-size: 18px;
    }
}
</style>
